module.exports = __webpack_public_path__ + "img/message1.e1ee9e1d.png";